import { render, staticRenderFns } from "./Partida.vue?vue&type=template&id=9f666810"
import script from "./Partida.vue?vue&type=script&lang=js"
export * from "./Partida.vue?vue&type=script&lang=js"
import style0 from "./Partida.vue?vue&type=style&index=0&id=9f666810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports